/** localStorage that never throws — private mode and locked-down browsers. */

export function readSetting<T extends string>(key: string, allowed: readonly T[], fallback: T): T {
  try {
    const value = window.localStorage.getItem(key);
    return value && (allowed as readonly string[]).includes(value) ? (value as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeSetting(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // A preference that cannot be remembered is not worth failing over.
  }
}

export const SETTINGS_KEYS = {
  theme: 'physical-movies.theme',
  language: 'physical-movies.language',
} as const;
